// src/modules/app-views/_apps/appmulti/leads/pages/Document/cardHeaderItems.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import {
  GlobalOutlined,
  MailOutlined,
  PhoneOutlined,
} from '@ant-design/icons';
import { FaPlaneArrival, FaPlaneDeparture } from 'react-icons/fa';
import dayjs from 'dayjs';
import translateX from 'utils/translateX';
import { parsePhoneToDisplay } from 'utils/helpers';

// *******************************************************************************
// HELPERS
// *******************************************************************************
const firstQuotation = record => record?.customData?.quotations?.[0];

// *******************************************************************************
// ITEMS
// *******************************************************************************
export const leadEmailItem = record => ({
  key: 'email',
  icon: <MailOutlined />,
  label: record?.email || null,
  tooltipText: translateX('email'),
  tooltipPlacement: 'right',
  onClick: null,
});

export const leadPhoneItem = record => ({
  key: 'phone',
  icon: <PhoneOutlined />,
  label: record?.phone ? parsePhoneToDisplay(record.phone) : null,
  tooltipText: translateX('phone'),
  tooltipPlacement: 'right',
  onClick: null,
});

export const leadDestinyItem = record => {
  const q = firstQuotation(record);
  return {
    key: 'destiny',
    icon: <GlobalOutlined />,
    label: q?.destiny ? translateX(q.destiny) : null,
    tooltipText: translateX('destiny'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const leadDepartureItem = record => {
  const q = firstQuotation(record);
  return {
    key: 'departure',
    icon: <FaPlaneDeparture />,
    label: q?.departure ? dayjs(q.departure).format('L') : null,
    tooltipText: translateX('departure'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const leadArrivalItem = record => {
  const q = firstQuotation(record);
  return {
    key: 'arrival',
    icon: <FaPlaneArrival />,
    label: q?.arrival ? dayjs(q.arrival).format('L') : null,
    tooltipText: translateX('arrival'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};
